import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PolicyService} from '../../../../../policy/services/policy.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {GlobalQuestionService} from 'src/app/modules/shared/services/global-question.service';
import {CalcPremDiffCollation, Collation, Policy, PolicyBenefitsAdded} from '../../../../models/policy.model';
import {EntryType} from '../../../../constants';
import { StorageService } from '../../../../services/storage.service';

declare var $: any;
declare var accounting: any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

enum ResumeDateSelection {
  Immediately = 'Immediately',
  EndOfMonth = 'EndOfMonth',
  SpecifiedDate = 'SpecifiedDate'
}

@Component({
    selector: 'app-resume-policy',
    templateUrl: './resume-policy.component.html',
    styleUrls: ['./resume-policy.component.scss'],
    standalone: false
})
export class ResumePolicyComponent implements OnInit, OnChanges {

  @Input() policy: Policy;
  @Input() item: Collation;
  @Input() vap: PolicyBenefitsAdded;
  @Input() source = '';
  @Input() new_session_id: any;
  @Input() entity = '';
  @Input() frequency_id = 3;
  @Input() isEditPolicyPage = false;
  @Output() getNewData = new EventEmitter<boolean>();

  resumeDateSelection = '';
  resumeDate = '';
  resumeDateValue: Date;
  refund: CalcPremDiffCollation;
  accounting: any;
  spinner = false;
  entities = Entity;
  resumeDateSelectionEnum = ResumeDateSelection;
  resumeSelectionDateModalButtonEnabled = false;

  constructor(
    private policyService: PolicyService,
    public datePipe: DatePipe,
    public router: Router,
    public questionService: GlobalQuestionService,
    private storageService: StorageService) {
  }

  ngOnInit(): void {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.policy?.currentValue !== changes?.policy?.previousValue) {
      this.policy = changes?.policy?.currentValue;
      if (this.accounting) {
        this.accounting.settings.currency.symbol = `${this.policy?.currency ? this.policy?.currency : 'R'} `;
      }
    }
    if (changes?.frequency_id?.currentValue !== changes?.frequency_id?.previousValue) {
      this.frequency_id = changes?.frequency_id?.currentValue;
    }
  }

  showResumeModal(entity: Entity, item?: any): void {
    this.entity = entity;
    if (item) {
      if (entity === Entity.Item) {
        this.item = item;
      } else if (entity === Entity.Vap) {
        this.vap = item;
      }
    }
    $('#resume-policy-alert-modal').modal('show');
  }

  onDateSelectionChange(): void {
    if (this.resumeDateSelection === ResumeDateSelection.Immediately) {
      this.resumeDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    } else if (this.resumeDateSelection === ResumeDateSelection.EndOfMonth) {
      const today = new Date();
      this.resumeDate = this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    if (this.resumeDate) {
      this.resumeSelectionDateModalButtonEnabled = true;
      this.resumeDateValue = new Date(this.resumeDate);
    } else {
      this.resumeSelectionDateModalButtonEnabled = false;
    }
  }

  onDatePickerChange(value: any): void {
    this.resumeDate = value;
    this.resumeDateValue = new Date(this.resumeDate);

    this.resumeSelectionDateModalButtonEnabled = !!this.resumeDate;
  }

  changeToActive(): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Item || this.entity === Entity.Vap) {
      if (this.isEditPolicyPage) {
        this.getNewData.emit(true);
      } else {
        this.policyService.submitPolicyUpdates(this.policy?.session_id)
          .subscribe(() => {
            this.questionService.spinner(false);
            $('#resume-policy-alert-modal').modal('hide');
            $('#resume-summary-page-two-modal').modal('hide');
            this.getNewData.emit(true);
          }, err => {
            this.questionService.spinner(false);
          });
      }
    } else if (this.entity === Entity.Policy) {
      this.policyService.submitPolicyUpdates(this.policy?.session_id)
        .subscribe(() => {
          this.questionService.spinner(false);
          $('#resume-policy-alert-modal').modal('hide');
          $('#resume-summary-page-two-modal').modal('hide');
          this.getNewData.emit(true);
          let documentPageRoute = this.storageService.get('previous-document-page', 'flow');
          this.router.navigate([documentPageRoute]);
        }, err => {
          this.questionService.spinner(false);
        });
    }
  }

  populateProperties(): void {
    this.questionService.spinner(true);
    console.log(this.frequency_id, this.policy)
    switch (this.entity) {
      case Entity.Policy:
        this.policyService.savePolicyUpdate(this.policy?.session_id, 3, 0, '0', this.resumeDate, this.resumeDate)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            $('#resume-policy-alert-modal').modal('hide');
            $('#resume-policy-alert-modal').on('hidden.bs.modal', () => {
              $('#resume-summary-page-two-modal').modal('show');
            });
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
          });
        break;
      case Entity.Item:
        this.policyService.savePolicyUpdate(this.policy?.session_id, 3, this.item?.class_id, this.item?.session_item_id, this.resumeDate, this.resumeDate)
          .subscribe(response => {
            $('#resume-policy-alert-modal').modal('hide');
            $('#resume-policy-alert-modal').on('hidden.bs.modal', () => {
              $('#resume-summary-page-two-modal').modal('show');
            });
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
          });
        break;
      case Entity.Vap:
        this.policyService.savePolicyUpdate(this.policy?.session_id, 3, this.vap?.class_id, this.vap?.session_item_id, this.resumeDate, this.resumeDate, this.vap?.vaps_id)
          .subscribe(response => {
            $('#resume-policy-alert-modal').modal('hide');
            $('#resume-policy-alert-modal').on('hidden.bs.modal', () => {
              $('#resume-summary-page-two-modal').modal('show');
            });
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
          });
        break;
    }
  }

  removeAction(status_id: number): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, 0, '0', 0, status_id)
        .subscribe(() => {
            const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
            this.policyService.calcPremDiff(this.policy?.session_id, today)
              .subscribe(() => {
                  this.policyService.submitPolicyUpdates(this.policy?.session_id)
                    .subscribe(() => {
                        this.questionService.spinner(false);
                      },
                      err => {
                        this.questionService.spinner(false);
                      });
                }, err => {
                  this.questionService.spinner(false);
                });
          },
          err => {
            this.questionService.spinner(false);
          });
    } else if (this.entity === Entity.Item) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.item?.class_id, this.item?.session_item_id, 0, status_id)
        .subscribe(() => {
            const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
            this.policyService.calcPremDiff(this.policy?.session_id, today)
              .subscribe(() => {
                  this.policyService.submitPolicyUpdates(this.policy?.session_id)
                    .subscribe(() => {
                        this.questionService.spinner(false);
                      }, err => {
                        this.questionService.spinner(false);
                      });
                }, err => {
                  this.questionService.spinner(false);
                });

          }, err => {
            this.questionService.spinner(false);
          });
    } else if (this.entity === Entity.Vap) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.vap?.class_id, this.vap?.session_item_id, 0, status_id, this.vap?.vaps_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    }
  }

  closeResumePolicyAlertModal(): void {
    $('#resume-policy-alert-modal').modal('hide');
  }

  closeResumeSummaryPageOneModal(): void {
    $('#resume-summary-page-one-modal').modal('hide');
  }

  closeResumeSummaryPageTwoModal(): void {
    $('#resume-summary-page-two-modal').modal('hide');
  }

  parseJSON(obj: string): any {
    try {
      return JSON.parse(obj)[0];
    } catch (e) {
      return JSON.parse(obj);
    }

  }
}
